var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 10.0002H8.75016M15.0002 12.5002L17.5002 10.0002L15.0002 7.50016M10.8335 5.8335V5.00016C10.8335 4.55814 10.6579 4.13421 10.3453 3.82165C10.0328 3.50909 9.60886 3.3335 9.16683 3.3335H5.00016C4.55814 3.3335 4.13421 3.50909 3.82165 3.82165C3.50909 4.13421 3.3335 4.55814 3.3335 5.00016V15.0002C3.3335 15.4422 3.50909 15.8661 3.82165 16.1787C4.13421 16.4912 4.55814 16.6668 5.00016 16.6668H9.16683C9.60886 16.6668 10.0328 16.4912 10.3453 16.1787C10.6579 15.8661 10.8335 15.4422 10.8335 15.0002V14.1668",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ab1f25f8b543fa3d921b72ae1bbec46d.svg";
export { ForwardRef as ReactComponent };